import {
    GET_PAYMENT_SUMMARY_REPORT_REQUEST,
    GET_PAYMENT_SUMMARY_REPORT_SUCCESS,
    GET_PAYMENT_SUMMARY_REPORT_ERROR
} from "../actions/types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getPaymentLedgerSummaryReport = (token, data) => (dispatch) => {
    // 

   
    dispatch({ type: GET_PAYMENT_SUMMARY_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/PaymentLedgerSummaryReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            from_date: moment(data.from_date).format("MM-DD-YYYY"),
            to_date: moment(data.to_date).format("MM-DD-YYYY"),
            customer_id: data?.customer_id === undefined || data?.customer_id === "" ? null : data?.customer_id,
            status: data.status === "All" ? null : data.status,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_PAYMENT_SUMMARY_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_PAYMENT_SUMMARY_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_PAYMENT_SUMMARY_REPORT_ERROR,
                payload: error.response,
            });
        });
};
